{
  "commandPalette": {
    "hint": "Поиск и переход · ⌘K",
    "placeholder": "Куда перейти…",
    "empty": "Ничего не найдено",
    "general": "Общее",
    "projects": "Проекты",
    "newProject": "Новый проект",
    "aiSettings": "Настройки AI",
    "systemPrompts": "Системные промпты",
    "mcp": "Claude / MCP",
    "profile": "Профиль",
    "about": "Обзор компании"
  },
  "nav": {
    "groups": {
      "workspace": "Рабочая область",
      "production": "Продакшн",
      "assets": "Ассеты",
      "settings": "Дополнительно"
    },
    "items": {
      "overview": "Обзор",
      "tasks": "Задачи",
      "seasons": "Сезоны и серии",
      "script": "Сценарий",
      "studio": "Студия",
      "studioAssembly": "Студия и сборка",
      "animatics": "Аниматики",
      "storyboard": "Storyboard",
      "flow": "Флоу",
      "assembly": "Монтаж",
      "canvas": "Холст",
      "characters": "Герои",
      "locations": "Локации",
      "props": "Реквизит",
      "scenes_3d": "3D Сцены",
      "presets": "Пресеты",
      "camera_presets": "Камеры",
      "library": "Библиотека",
      "versions": "Версии",
      "settings": "Настройки",
      "team": "Команда",
      "billing": "Биллинг",
      "generation_skills": "Скиллы",
      "analytics": "Аналитика"
    }
  },
  "shell": {
    "nav": {
      "loading": "Загрузка страницы",
      "stalled": "Страница загружается дольше обычного",
      "reload": "Обновить"
    },
    "root": {
      "feed": "Лента",
      "projects": "Проекты",
      "tasks": "Задачи",
      "newProject": "Новый проект"
    },
    "studio": {
      "aiSettings": "Настройки AI",
      "systemPrompts": "Промпты",
      "agreements": "Соглашения",
      "styleCatalog": "Каталог стилей",
      "cameras": "Камеры",
      "presentations": "Презентации",
      "splashAnnouncements": "Объявления",
      "generationModels": "Реестр моделей",
      "providerConnections": "Провайдеры",
      "platformConfig": "Платформа",
      "skills": "Скиллы"
    },
    "monitoring": {
      "generations": "Генерации",
      "dialogs": "Агенты",
      "queueJobs": "Очереди джоб",
      "section": "Мониторинг"
    },
    "billing": {
      "dashboard": "Дашборд",
      "usage": "Журнал",
      "plans": "Планы",
      "promotions": "Акции",
      "promoCodes": "Промокоды",
      "accounts": "Счета",
      "invoices": "Счета на оплату",
      "proposals": "Коммерческие предложения",
      "spendReports": "Сводки расходов",
      "onlinePayments": "Онлайн-платежи",
      "supplier": "Реквизиты",
      "priceList": "Прайс-лист",
      "costRates": "Себестоимость",
      "section": "Биллинг",
      "tariffs": "Тарифы"
    },
    "company": {
      "overview": "Обзор",
      "aiSettings": "Настройки AI",
      "canvas": "Холст",
      "prompts": "Промпты",
      "cameras": "Камеры",
      "members": "Сотрудники",
      "models": "Модели",
      "skills": "Скиллы",
      "billing": "Биллинг"
    },
    "sidebar": {
      "expandMenu": "Развернуть меню",
      "collapseMenu": "Свернуть меню",
      "platform": "Платформа",
      "studio": "Студия",
      "company": "Компания",
      "companies": "Компании",
      "users": "Пользователи",
      "projects": "Каталог проектов",
      "catalogs": "Каталоги",
      "logout": "Выйти",
      "logoutConfirm": "Выйти из аккаунта?",
      "openMenu": "Открыть меню",
      "closeMenu": "Закрыть меню"
    },
    "companyHeader": {
      "railTooltip": "{{company}} · {{role}}",
      "superAdmin": "Superadmin",
      "archivedBadge": "Архив",
      "archivedTooltip": "{{company}} · в архиве"
    },
    "spendLimit": {
      "title": "Лимит расходов",
      "tooltip": "Месяц: осталось {{left}} · {{resets}}",
      "month": "Месяц · {{limit}}",
      "topup": "включая {{amount}} до конца месяца"
    },
    "companyMenu": {
      "open": "Сменить компанию",
      "invitations": "Приглашения · {{count}}",
      "accept": "Принять",
      "decline": "Отклонить",
      "createCompany": "Создать компанию",
      "about": "Обзор компании",
      "search": "Найти компанию…",
      "searchEmpty": "Ничего не найдено",
      "close": "Закрыть",
      "favorites": "Избранное",
      "recent": "Недавние",
      "favoritesEmpty": "Отметьте звёздочкой компании, в которые заходите чаще всего, — они появятся здесь.",
      "recentEmpty": "Здесь появятся компании, в которые вы недавно переключались.",
      "addFavorite": "Добавить в избранное",
      "removeFavorite": "Убрать из избранного",
      "hide": "Скрыть из списка",
      "unhide": "Вернуть в список",
      "hidden": "Скрытые · {{count}}"
    },
    "userMenu": {
      "open": "Меню аккаунта",
      "profile": "Профиль",
      "language": "Язык",
      "languageRu": "Русский",
      "languageEn": "English",
      "back": "Назад",
      "theme": "Тема",
      "themeDark": "Тёмная",
      "themeLight": "Светлая"
    },
    "invitationBanner": {
      "prefix": "Вас пригласили в",
      "suffix": "как {{role}}",
      "roleAs": {
        "owner": "Владельца",
        "member": "Сотрудника"
      },
      "dismiss": "Скрыть до следующего входа"
    },
    "header": {
      "search": "Поиск",
      "jobs": "Задачи",
      "savingToDisk": "Сохраняем на диск",
      "contextAria": "Контекст",
      "agentColumnShow": "Показать агента",
      "agentColumnHide": "Скрыть агента",
      "agentReply": "Агент ответил"
    },
    "drawer": {
      "closePanel": "Закрыть панель",
      "settings": "Настройки",
      "jobs": "Задачи",
      "agents": "Агенты",
      "notes": "Заметки",
      "versions": "Версии",
      "openProjectForModels": "Откройте проект для настройки моделей.",
      "openProjectForJobs": "Откройте проект для просмотра задач."
    },
    "error": {
      "hideDetails": "Скрыть подробности",
      "showDetails": "Подробности"
    },
    "openRouter": {
      "checkGeneration": "Проверить генерацию",
      "checkHint": "Вставьте generation_id из OpenRouter Dashboard для восстановления изображения.",
      "check": "Проверить",
      "enterGenerationId": "Введите generation_id.",
      "imageSaved": "Изображение сохранено.",
      "imageNotFound": "Изображение не найдено.",
      "networkUnavailable": "Сеть недоступна.",
      "request": "Запрос",
      "response": "Ответ",
      "payloadNotSaved": "Payload не сохранён",
      "responseNotSaved": "Ответ не сохранён",
      "noSavedLogs": "Нет сохранённых логов запросов."
    },
    "recover": {
      "checkAndFetch": "Проверить генерацию и дополучить файл",
      "hint": "Опросим задачу по её ID и сохраним результат, если он готов.",
      "checking": "Проверяем…",
      "fetched": "Видео дополучено и сохранено.",
      "failed": "Не удалось дополучить файл.",
      "networkUnavailable": "Сеть недоступна."
    },
    "versions": {
      "scope": {
        "scenes": "Сцены",
        "episodes": "Серии",
        "characters": "Герои",
        "season_structure": "Сезон",
        "shots": "Шоты"
      },
      "restoreHint": {
        "episodes": "Заменит все серии выбранного сезона и вложенные сцены и шоты на состояние из снимка. Текущее состояние перед этим сохраняется в новой записи версий.",
        "scenes": "Архивирует текущие активные сцены и шоты серии и восстанавливает дерево из снимка. Медиа и записи старых сцен остаются в базе."
      },
      "intro": "Снимки перед перегенерацией. Восстановление для «сцен» не удаляет старые записи и вложения — они помечаются архивом.",
      "fullHistoryLink": "Полная история и JSON →",
      "openProject": "Откройте проект, чтобы видеть снимки.",
      "noSnapshots": "Пока нет автоматических снимков.",
      "restoreConfirm": "{{hint}}\n\nПродолжить восстановление снимка «{{label}}»?",
      "makeActive": "Сделать активным",
      "doubleClickRestore": "Двойной клик — восстановить из снимка (с подтверждением)",
      "restoreUnavailable": "Восстановление недоступно."
    },
    "admin": {
      "title": "Администрирование",
      "search": "Найти раздел: компании, промпты, себестоимость…",
      "close": "Закрыть",
      "favorites": "Избранное",
      "recent": "Недавнее",
      "favoritesEmpty": "Отметьте звёздочкой разделы, которые открываете чаще всего, — они появятся здесь.",
      "recentEmpty": "Здесь появятся разделы, которые вы открывали из этого меню.",
      "attention": "Требует внимания",
      "noResults": "Таких разделов нет. Попробуйте другое слово, например «оплата» или «модели».",
      "addFavorite": "Добавить в избранное",
      "removeFavorite": "Убрать из избранного"
    },
    "adminGroups": {
      "generation": "Генерация",
      "service": "Сервис"
    }
  },
  "appReload": {
    "hint": "Чтобы продолжить работу, перезагрузите страницу.",
    "hintOutdated": "Вышла новая версия приложения — перезагрузите страницу.",
    "action": "Обновить",
    "bannerText": "Доступна новая версия приложения",
    "bannerDismiss": "Скрыть"
  }
}
